module.exports = __webpack_public_path__ + "static/media/szablony_emaili_do_klientów_420x240px.c90db136.png";